import { DrillDifficulty, DrillCategory, AgeGroup } from '../Model';

export type DifficultyColorScheme = {
  bg: string;
  text: string;
  border: string;
};

export type CategoryColorScheme = {
  bg: string;
  text: string;
};

export type AgeGroupColorScheme = {
  bg: string;
  text: string;
  border: string;
};

export const getDifficultyColor = (difficulty: DrillDifficulty): DifficultyColorScheme => {
  switch (difficulty) {
    case 'Beginner':
      return { bg: 'rgba(34, 197, 94, 0.15)', text: '#4ade80', border: 'rgba(34, 197, 94, 0.3)' };
    case 'Intermediate':
      return { bg: 'rgba(234, 179, 8, 0.15)', text: '#facc15', border: 'rgba(234, 179, 8, 0.3)' };
    case 'Advanced':
      return { bg: 'rgba(239, 68, 68, 0.15)', text: '#f87171', border: 'rgba(239, 68, 68, 0.3)' };
  }
};

export const getCategoryColor = (category: DrillCategory): CategoryColorScheme => {
  switch (category) {
    case 'Warm-up':
      return { bg: 'rgba(234, 179, 8, 0.15)', text: '#facc15' };
    case 'Main':
      return { bg: 'rgba(139, 92, 246, 0.15)', text: '#a78bfa' };
    case 'Cool-down':
      return { bg: 'rgba(6, 182, 212, 0.15)', text: '#22d3ee' };
    case 'Game':
      return { bg: 'rgba(34, 197, 94, 0.15)', text: '#4ade80' };
  }
};

export const getAgeGroupColor = (ageGroup: AgeGroup): AgeGroupColorScheme => {
  switch (ageGroup) {
    case 'Mini':
      return { bg: 'rgba(236, 72, 153, 0.15)', text: '#f472b6', border: 'rgba(236, 72, 153, 0.3)' };
    case 'Youth':
      return { bg: 'rgba(59, 130, 246, 0.15)', text: '#60a5fa', border: 'rgba(59, 130, 246, 0.3)' };
    case 'Junior':
      return { bg: 'rgba(245, 158, 11, 0.15)', text: '#fbbf24', border: 'rgba(245, 158, 11, 0.3)' };
    case 'Senior':
      return { bg: 'rgba(34, 197, 94, 0.15)', text: '#4ade80', border: 'rgba(34, 197, 94, 0.3)' };
  }
};
